export default __webpack_public_path__ + "static/media/welcome.e9439573.svg";